import moment from 'moment';

export function toDMY(datetime){
   if(datetime===null || typeof datetime === undefined){
      return "-";
   }
   return momenGet(datetime).format('DD/MM/YYYY HH:mm:ss');
}

export function toDMYDate(datetime){
   if(datetime===null || typeof datetime === undefined){
      return "-";
   }
  return momenGet(datetime).format('DD/MM/YYYY');
}

function momenGet(date){
   return moment(date);
}


// WEBPACK FOOTER //
// ./src/_utils/convert_datetime.js